var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-662 -7752) translate(0 7554) translate(662 198)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9FA7D1",
    d: "M18.61 15.503c-1.45-1.171-2.284-2.885-2.284-4.698V8.25c0-3.226-2.51-5.896-5.762-6.343v-.99c0-.507-.43-.917-.96-.917s-.961.41-.961.917v.99C5.39 2.354 2.88 5.024 2.88 8.25v2.556c0 1.814-.833 3.526-2.293 4.705-.373.306-.588.75-.588 1.219 0 .884.753 1.604 1.681 1.604h15.845c.927 0 1.681-.719 1.681-1.604 0-.47-.214-.913-.596-1.227z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A80A8",
    d: "M9.604 23c1.738 0 3.193-1.183 3.527-2.75H6.075C6.41 21.817 7.865 23 9.604 23z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    x: 11.5,
    y: 1.5,
    fill: "#F11D2D",
    stroke: "#FFF",
    rx: 3
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.b9b9764c67cd09125f1e3eab9e791e4c.svg";
export { ForwardRef as ReactComponent };